module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kansai-2-8ba3634ee680b8b49cb402f5987553e5.png";